import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const cats = [
  { name: "Laces & Trims", img: "/api/files/innus-lace/products/p05.jpg", span: "md:col-span-2 md:row-span-2", tall: true },
  { name: "Beads & Sequins", img: "/api/files/innus-lace/products/p10.jpg", span: "md:col-span-2 md:row-span-2", tall: true },
];

export const Categories = ({ onSelect }) => (
  <section
    id="collections"
    data-testid="categories-section"
    className="py-28 md:py-40 bg-[#F2EFEB]"
  >
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="flex flex-wrap items-end justify-between gap-6 mb-14 md:mb-20">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="font-serif-d font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#2D1B36]"
        >
          Browse the <span className="italic text-[#C5A059]">shelves</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="font-accent text-xs tracking-[0.3em] uppercase text-[#8A818F]"
        >
          Fresh stock · Straight from Court Road
        </motion.p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 auto-rows-[220px] md:auto-rows-[260px] gap-4 md:gap-5">
        {cats.map((c, i) => (
          <motion.button
            key={c.name}
            data-testid={`category-tile-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            onClick={() => onSelect(c.name)}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.7, delay: 0.06 * i }}
            className={`relative overflow-hidden group text-left ${c.span}`}
          >
            <img
              src={c.img}
              alt={c.name}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-[#2D1B36]/30 group-hover:bg-[#2D1B36]/50 transition-colors duration-500" />
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-2">
              <span className="font-serif-d text-2xl md:text-3xl text-[#FBF9F6] text-center px-4">
                {c.name}
              </span>
              <span className="font-accent text-[10px] tracking-[0.3em] uppercase text-[#DFCA9B] opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-[opacity,transform] duration-500 flex items-center gap-1">
                Shop now <ArrowUpRight size={12} />
              </span>
            </div>
          </motion.button>
        ))}
      </div>
    </div>
  </section>
);
